import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import numeral from 'numeral';
import { Url, URLS } from '@wix/da-url';
import { BiData, TopNavMenuClickBiEvent } from '@wix/da-bi/pkg/events';
import type { MenuItem } from '@wix/da-ds/pkg/Dropdown/MenuList';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import SuffixText from '../_partials/SuffixText';
import { UserMenuContext } from '../UserMenuMobile/UserMenuContext';

export function usePointsBalanceItem(): MenuItem {
  const { t } = useTranslation();
  const { counts } = useContext(SessionContext);
  const { isOpen: isUserMenuOpen } = useContext(UserMenuContext);
  const isMobile = useContext(MobileContext);

  return {
    label: t('siteHeaderMobile.userMenu.pointsBalance'),
    suffix: (
      <SuffixText>{numeral(counts?.points ?? 0).format('0,0')}</SuffixText>
    ),
    link: Url.buildFromPath(URLS.POINTS),
    biData: BiData<TopNavMenuClickBiEvent>({
      evid: 702,
      link_url: Url.buildFromPath(URLS.POINTS),
      menu_item: 'pointsBalance',
      menu_name: 'profile',
    }),
    tabIndex: isUserMenuOpen || !isMobile ? 0 : -1,
  };
}
